import * as _ from 'lodash';

import { ADD_MANAGERS, ManagersAction, SET_MANAGERS_LOADING } from '@Actions/managersAction';

import { IUserModel } from '@Shared/models';

interface IManagersState {
  managers: IUserModel[];
  managersLoading: boolean;
}

export const defaultState: IManagersState = {
  managers: [],
  managersLoading: false
};

export default function (state = defaultState, action: ManagersAction): IManagersState {
  switch (action.type) {
    case ADD_MANAGERS:
      return _.assign({}, state, {
        managers: _.uniqBy([...action.payload, ...state.managers], (manager) => manager.id)
      });
    case SET_MANAGERS_LOADING:
      return {
        ...state,
        managersLoading: action.payload
      };
    default:
      return state;
  }
}
